// GENERATED by scripts/sync-veto-engine.js from server/services/ext/vetoEngine.js — do not edit here.
// The browser runs the external-tournament veto with this; the server replays it on submit.
/* eslint-disable */
export function vetoInitialState(mapNames) {
  return {
    step: 0,
    maps: mapNames.map(name => ({ name, status: 'available', by: null, side: null, sideBy: null })),
    played: [],
    log: [],
  };
}

export function vetoClone(s) {
  return { step: s.step, maps: s.maps.map(m => ({ ...m })), played: s.played.slice(), log: s.log.map(l => ({ ...l })) };
}

export function vetoLeftoverDecider(s, knife) {
  const left = s.maps.filter(m => m.status === 'available');
  if (left.length !== 1) return null;
  const m = left[0];
  m.status = 'decider'; m.by = 'System';
  if (knife) m.side = 'knife';
  s.played.push(m.name);
  s.log.push({ team: null, action: 'decider', map: m.name, side: knife ? 'knife' : null });
  return m;
}

export function vetoRunSystemSteps(steps, s) {
  while (s.step < steps.length && steps[s.step].t === 'System') {
    if (steps[s.step].a === 'knife') vetoLeftoverDecider(s, true);
    s.step++;
  }
}

/** Apply one admin input ({ map } for ban/pick, { side: 'ct'|'t' } for side). Returns { state } or { error }. */
export function vetoApply(steps, state, input) {
  const s = vetoClone(state);
  vetoRunSystemSteps(steps, s);
  const step = steps[s.step];
  if (!step) return { error: 'The veto is already complete' };
  input = input || {};
  if (step.a === 'ban' || step.a === 'pick') {
    const m = s.maps.find(x => x.name === input.map);
    if (!m) return { error: `Unknown map: ${input.map}` };
    if (m.status !== 'available') return { error: `${input.map} is no longer available` };
    m.status = step.a === 'ban' ? 'banned' : 'picked';
    m.by = step.t;
    if (step.a === 'pick') s.played.push(m.name);
    s.log.push({ team: step.t, action: step.a, map: m.name });
  } else if (step.a === 'side') {
    if (input.side !== 'ct' && input.side !== 't') return { error: 'side must be ct or t' };
    const prev = s.step > 0 ? steps[s.step - 1] : null;
    let m = prev && prev.a === 'pick' ? s.maps.find(x => x.name === s.played[s.played.length - 1]) : null;
    if (!m) m = vetoLeftoverDecider(s, false);
    if (!m) return { error: 'No map to choose a side on' };
    m.side = input.side; m.sideBy = step.t;
    s.log.push({ team: step.t, action: 'side', map: m.name, side: input.side });
  } else {
    return { error: `Unsupported step: ${step.a}` };
  }
  s.step++;
  vetoRunSystemSteps(steps, s);
  return { state: s };
}

/** Replay a list of inputs from the start. Returns { state } or { error, at }. */
export function vetoReplay(steps, mapNames, inputs) {
  let s = vetoInitialState(mapNames);
  vetoRunSystemSteps(steps, s);
  for (let i = 0; i < inputs.length; i++) {
    const r = vetoApply(steps, s, inputs[i]);
    if (r.error) return { error: r.error, at: i };
    s = r.state;
  }
  return { state: s };
}

export function vetoDone(steps, state) { return state.step >= steps.length; }

/** The step waiting for input (System steps are never waiting), or null when done. */
export function vetoCurrentStep(steps, state) { return state.step < steps.length ? steps[state.step] : null; }

/** For a 'side' step: the map the side is chosen on (the last pick, or the map left over). */
export function vetoSideMap(steps, state) {
  const step = steps[state.step];
  if (!step || step.a !== 'side') return null;
  const prev = state.step > 0 ? steps[state.step - 1] : null;
  if (prev && prev.a === 'pick') return state.played[state.played.length - 1] || null;
  const left = state.maps.filter(m => m.status === 'available');
  return left.length === 1 ? left[0].name : null;
}
